import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReactHtmlParser from 'react-html-parser';
import DataTable from "react-data-table-component";

import { API_BASE_URL } from '../../config.js';

const Dept_ot = ({ fixNavbar }) => {

  const [data, setData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedIds, setSelectedIds] = useState([]);

  /* ================= FETCH DATA ================= */
  const fetchData = () => {
    axios.get(`${API_BASE_URL}/dept_overtime_list`, {
      headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` }
    })
    .then(res => setData(res.data || []))
    .catch(() => toast.error("Failed to load overtime list"));
  };

  useEffect(() => {
    fetchData();
  }, []);

  /* ================= SEARCH ================= */
  const filteredData = data.filter(item =>
    `${item.employee_id}${item.employee_name}${item.department_name}`
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  /* ================= SELECTABLE ROWS ================= */
  const selectableRows = filteredData.filter(
    row => row.floor_status === 2 && row.dept_status === 1
  );

  const isAllSelected =
    selectableRows.length > 0 &&
    selectableRows.every(row => selectedIds.includes(row.overtime_id));

  const toggleSelectAll = () => {
    if (isAllSelected) {
      setSelectedIds([]);
    } else {
      setSelectedIds(selectableRows.map(row => row.overtime_id));
    }
  };

  const handleCheckboxChange = (id) => {
    setSelectedIds(prev =>
      prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]
    );
  };

  /* ================= BULK APPROVE ================= */
  const approveSelected = () => {
    if (selectedIds.length === 0) {
      toast.warn("No records selected!", { position: "bottom-right" });
      return;
    }

    axios.post(
      `${API_BASE_URL}/dept_overtime_approve_bulk`,
      { overtime_ids: selectedIds, status: "Approved" },
      { headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` } }
    )
    .then(() => {
      toast.success("Selected records approved!", { position: "bottom-right" });
      setSelectedIds([]);
      fetchData();
    })
    .catch(() => toast.error("Failed to approve!"));
  };

  /* ================= DATATABLE COLUMNS ================= */
  const columns = [
    {
      name: (
        <input
          type="checkbox"
          checked={isAllSelected}
          onChange={toggleSelectAll}
        />
      ),
      cell: row =>
        row.floor_status === 2 && row.dept_status === 1 ? (
          <input
            type="checkbox"
            checked={selectedIds.includes(row.overtime_id)}
            onChange={() => handleCheckboxChange(row.overtime_id)}
          />
        ) : null,
      ignoreRowClick: true,
      width: "60px",
    },
   {
  name: "Action",
  selector: row =>
    Number(row.floor_status) === 2 &&
    Number(row.dept_status) === 1
      ? 1
      : 0,
  sortable: true,
  cell: row =>
    Number(row.floor_status) === 2 &&
    Number(row.dept_status) === 1 ? (
      <Link to={`/deptotdetails?id=${row.overtime_id}`} title="View Details">
        <i className="fe fe-maximize" />
      </Link>
    ) : null,
  ignoreRowClick: true,
  width: "100px",
}
,
    { name: "Employee ID", selector: row => row.employee_id, sortable: true },
    { name: "Employee", selector: row => row.employee_name, sortable: true },
    { name: "Department", selector: row => row.department_name, sortable: true },
    { name: "Overtime Hours", selector: row => row.overtime_hour, sortable: true },
    { name: "Overtime Date", selector: row => row.overtime_date, sortable: true },
{
  name: "Reason",
  cell: row => {
    const reason = row.reason || "";
    const plainText = reason.replace(/<[^>]+>/g, ""); // remove HTML tags
    const shortText =
      plainText.length > 5 ? plainText.substring(0, 5) + "..." : plainText;

    return (
      <div className="remark-hover-wrapper">
        {shortText}
        <div className="remark-hover-box">
          {plainText}
        </div>
      </div>
    );
  },
  sortable: true,
  wrap: true,
}
,{
  name: "Incharge Remark",
  cell: row => {
    const remark = row.incharge_remark || "";
    const plainText = remark.replace(/<[^>]+>/g, ""); // remove HTML tags
    const shortText =
      plainText.length > 5 ? plainText.substring(0, 5) + "..." : plainText;

    return (
      <div className="remark-hover-wrapper">
        {shortText}
        <div className="remark-hover-box">
          {plainText}
        </div>
      </div>
    );
  },
  sortable: true,
}
,
  { name: "Incharge", cell: row => ReactHtmlParser(row.incharge_status) },
    { name: "HOD", cell: row => ReactHtmlParser(row.hod_status) },
    { name: "HR", cell: row => ReactHtmlParser(row.hr_status) },
  ];

  return (
    <>
      <ToastContainer />
      <div className={`section-body ${fixNavbar ? "marginTop" : ""}`}>
        <div className="container-fluid">
          <div className="card">

            {/* HEADER */}
            <div className="card-header d-flex justify-content-between align-items-center">
              <h3 className="card-title mb-0" style={{ color: '#e96827' }}>
                Overtime List
              </h3>

              <input
                type="text"
                className="form-control form-control-sm"
                placeholder="Search"
                value={searchTerm}
                onChange={e => setSearchTerm(e.target.value)}
                style={{ width: "250px" }}
              />
            </div>

            {/* TABLE */}
            <div className="card-body">
              <DataTable
                columns={columns}
                data={filteredData}
                pagination
                paginationRowsPerPageOptions={[10, 25, 50, 100]}
                highlightOnHover
                striped
                responsive
                persistTableHead
                noDataComponent="No overtime records found"
              />

              <button
                className="btn btn-warning mt-3"
                onClick={approveSelected}
              >
                Approve Selected
              </button>
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  fixNavbar: state.settings.isFixNavbar
});

export default connect(mapStateToProps)(Dept_ot);
